import { useEffect } from 'react';

const useHideHubSpotChat = (shouldHideChat: boolean) => {
    useEffect(() => {
        if (window.HubSpotConversations && window.HubSpotConversations.widget) {
            if (shouldHideChat) {
                window.HubSpotConversations.widget.remove();
            } else if (window.innerWidth > 768) {
                // On mobile the bubble is intentionally hidden — never auto-reload it
                window.HubSpotConversations.widget.load();
            }
        }
    }, [shouldHideChat]);
};

export default useHideHubSpotChat;
